import { __makeTemplateObject } from '../../../../../../node_modules/tslib/tslib.es6.js';
import { styled } from '@mui/system';

var HeaderLinksContainer = styled("nav")(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  gap: 28px;\n  user-select: none;\n\n  a {\n    color: ", ";\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 28px;\n    letter-spacing: 0.55px;\n    text-decoration: none;\n    transition: color 0.2s;\n\n    &:hover {\n      color: ", ";\n    }\n\n    &.active {\n      &,\n      &:hover {\n        color: ", ";\n      }\n    }\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  gap: 28px;\n  user-select: none;\n\n  a {\n    color: ", ";\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 28px;\n    letter-spacing: 0.55px;\n    text-decoration: none;\n    transition: color 0.2s;\n\n    &:hover {\n      color: ", ";\n    }\n\n    &.active {\n      &,\n      &:hover {\n        color: ", ";\n      }\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.palette.neutral200;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.neutral100;
}, function (_a) {
    var theme = _a.theme;
    return theme.palette.highlighted;
});
var templateObject_1;

export { HeaderLinksContainer };
